import { fieldProcessor2 } from "../common";
import { fieldRenderedAction } from "../../actions";
import {
  onCardSchemaChange,
  onCvvChange,
  onCvvInput,
  onCvvKeyDown,
} from "./cvvHandlers";
import { notifyParent } from "../iframeNotifications";

export const onReady = () => {
  notifyParent(fieldRenderedAction("cvv"));

  const field = document.querySelector("input") as HTMLInputElement;

  field.addEventListener("change", onCvvChange);
  field.addEventListener("keydown", onCvvKeyDown);
  field.addEventListener("input", onCvvInput);
  window.addEventListener("message", onCardSchemaChange);
};

fieldProcessor2(onReady);
